const broker_contact = "mailto:sales@hy.ly";
const support_contact = "mailto:support@hy.ly";
const switcherNotify_link =
  "https://support.hy.ly/portal/kb/articles/navigating-the-new-hy-ly-app-switcher";
const utm_code = `?utm_medium=Email&utm_source=Hyly&utm_campaign=eBlast&utm_content={%email_name_encoded%}`;
export { broker_contact, support_contact, switcherNotify_link, utm_code };
